function createRuler(lengthInInches, elementId, pxPerInch = 5, orientation = "horizontal", labelStep) {
  const container = document.getElementById(elementId);
  if (!container) {
    console.error("Container not found:", elementId);
    return;
  }

  const dpr = window.devicePixelRatio || 1; // detect high DPI screens

  // Remove old canvas
  const existingCanvas = container.querySelector("canvas");
  if (existingCanvas) existingCanvas.remove();

  // Create canvas
  const canvas = document.createElement("canvas");
  const isHorizontal = orientation === "horizontal";

  // CSS dimensions (in normal pixels)
  let cssWidth, cssHeight;
  if (isHorizontal) {
    cssWidth = lengthInInches * pxPerInch;
    cssHeight = 30; // a bit taller to fit larger ticks
  } else {
    cssWidth = 30;
    cssHeight = lengthInInches * pxPerInch;
  }

  // Internal resolution scaled by DPR
  canvas.width = cssWidth * dpr;
  canvas.height = cssHeight * dpr;

  // CSS size
  // canvas.style.width = cssWidth + "px";
  // canvas.style.height = cssHeight + "px";

  container.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr); // scale for high DPI
  ctx.font = "14px Open Sans,sans-serif"; // slightly bigger text
  ctx.fillStyle = "#717070db";
  ctx.strokeStyle = "#717070db";



  if (isHorizontal) {
    const baseY = cssHeight;

    for (let i = 0; i <= lengthInInches; i++) {
      const x = i * pxPerInch;
      const feet = i / 12;

      if (i % 12 === 0) {
        // Major tick
        ctx.beginPath();
        if (i === 0){
        ctx.moveTo(x + 2, baseY);
        ctx.lineTo(x + 2, baseY - 12);
        }else if (i === lengthInInches){
        ctx.moveTo(x -2, baseY);
        ctx.lineTo(x -2, baseY - 12);
        }else{
        ctx.moveTo(x, baseY);
        ctx.lineTo(x, baseY - 12);
        }

        ctx.lineWidth = 2;
        ctx.stroke();

        if (feet % labelStep === 0) {
          ctx.textAlign = "center";
          if (i === 0) ctx.textAlign = "left";
          if (i === lengthInInches) ctx.textAlign = "right";
          ctx.fillText(`${feet}ft`, x, baseY - 17);
        }
      } else if (i % 6 === 0) {
        // Medium tick
        ctx.beginPath();
        ctx.moveTo(x, baseY);
        ctx.lineTo(x, baseY - 10);
        ctx.lineWidth = 1;
        ctx.stroke();
      } else {
        // Small tick
        ctx.beginPath();
        ctx.moveTo(x, baseY);
        ctx.lineTo(x, baseY - 8);
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    }
  } else {
    const baseX = cssWidth - 1; // ticks on right edge

    for (let i = 0; i <= lengthInInches; i++) {
      const y = cssHeight - (i * pxPerInch); // bottom → top
      const feet = i / 12;

      if (i % 12 === 0) {
        // Major tick
        ctx.beginPath();
        ctx.moveTo(baseX, y);
        ctx.lineTo(baseX - 12, y);
        ctx.lineWidth = 2;
        ctx.stroke();

        if (feet % labelStep === 0) {
          ctx.save();
          ctx.translate(12, y);
          ctx.rotate(-Math.PI / 2);
          ctx.textAlign = "center";
          if (i === 0) ctx.fillText(`${feet}ft`, 12, 0);
          else if (i === lengthInInches) ctx.fillText(`${feet}ft`, -14, 0);
          else ctx.fillText(`${feet}ft`, 0, 0);
          ctx.restore();
        }
      } else if (i % 6 === 0) {
        // Medium tick
        ctx.beginPath();
        ctx.moveTo(baseX, y);
        ctx.lineTo(baseX - 10, y);
        ctx.lineWidth = 1;
        ctx.stroke();
      } else {
        // Small tick
        ctx.beginPath();
        ctx.moveTo(baseX, y);
        ctx.lineTo(baseX - 8, y);
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    }
  }
}




function createRulerMeters(lengthInInches, elementId, pxPerInch = 5, orientation = "horizontal", labelStep, lengthInCm) {
  console.log(lengthInCm, 'lengthInCm');
  const container = document.getElementById(elementId);
  if (!container) {
    console.error("Container not found:", elementId);
    return;
  }

  const dpr = window.devicePixelRatio || 1;

  // Remove old canvas
  const existingCanvas = container.querySelector("canvas");
  if (existingCanvas) existingCanvas.remove();

  // Create canvas
  const canvas = document.createElement("canvas");
  const isHorizontal = orientation === "horizontal";

  let cssWidth, cssHeight;
  if (isHorizontal) {
    cssWidth = lengthInInches * pxPerInch;
    cssHeight = 30; // allow space for ticks + text
  } else {
    cssWidth = 30;
    cssHeight = lengthInInches * pxPerInch;
  }

  canvas.width = cssWidth * dpr;
  canvas.height = cssHeight * dpr;
  // canvas.style.width = cssWidth + "px";
  // canvas.style.height = cssHeight + "px";

  container.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  ctx.font = "14px Open Sans,sans-serif";
  ctx.fillStyle = "#717070db";
  ctx.strokeStyle = "#717070db";



  if (isHorizontal) {
    const baseY = cssHeight;

    for (let cm = 0; cm <= lengthInCm; cm++) {
      const x = (cm / 2.54) * pxPerInch;
      const meters = cm / 100;

      if (cm % 100 === 0) {
        // Major tick (1m)
        ctx.beginPath();
        if (cm === 0){
        ctx.moveTo(x + 2, baseY);
        ctx.lineTo(x + 2, baseY - 12);
        }else if (Math.abs(cm - lengthInCm) < 1){
        ctx.moveTo(x - 4, baseY);
        ctx.lineTo(x - 4, baseY - 12);
        }else{
        ctx.moveTo(x, baseY);
        ctx.lineTo(x, baseY - 12);
        }
        ctx.lineWidth = 2;
        ctx.stroke();

        if (meters % labelStep === 0) {
          ctx.textAlign = "center";
          if (cm === 0) ctx.fillText(`${meters}m`, x + 12, baseY - 15);
          else if (Math.abs(cm - lengthInCm) < 1) ctx.fillText(`${meters}m`, x - 12, baseY - 18);
          else ctx.fillText(`${meters}m`, x, baseY - 15);
        }
      } else if (cm % 50 === 0) {
        // Medium tick (50cm)
        ctx.beginPath();
        ctx.moveTo(x, baseY);
        ctx.lineTo(x, baseY - 10);
        ctx.lineWidth = 1;
        ctx.stroke();
      } else if (cm % 10 === 0) {
        // Minor tick (10cm)
        ctx.beginPath();
        ctx.moveTo(x, baseY);
        ctx.lineTo(x, baseY - 8);
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    }
  } else {
    const baseX = cssWidth - 1;

    for (let cm = 0; cm <= lengthInCm; cm++) {
      const y = cssHeight - (cm / 2.54) * pxPerInch; // bottom → top
      const meters = cm / 100;

      if (cm % 100 === 0) {
        // Major tick (1m)
        ctx.beginPath();
        if (cm === 0){
        ctx.moveTo(baseX, y - 2);
        ctx.lineTo(baseX - 12, y - 2);
        }else if (Math.abs(cm - lengthInCm) < 1){
        ctx.moveTo(baseX, y + 4);
        ctx.lineTo(baseX - 12, y + 4);
        }else{
        ctx.moveTo(baseX, y);
        ctx.lineTo(baseX - 12, y);
        }
        ctx.lineWidth = 2;
        ctx.stroke();

        if (meters % labelStep === 0) {
          ctx.save();
          ctx.translate(12, y);
          ctx.rotate(-Math.PI / 2);
          ctx.textAlign = "center";

          if (cm === 0) ctx.fillText(`${meters}m`, 12, 0);
          else if (Math.abs(cm - lengthInCm) < 1) ctx.fillText(`${meters}m`, -14, 0);
          else ctx.fillText(`${meters}m`, 0, 0);

          ctx.restore();
        }
      } else if (cm % 50 === 0) {
        // Medium tick (50cm)
        ctx.beginPath();
        ctx.moveTo(baseX, y);
        ctx.lineTo(baseX - 10, y);
        ctx.lineWidth = 1;
        ctx.stroke();
      } else if (cm % 10 === 0) {
        // Minor tick (10cm)
        ctx.beginPath();
        ctx.moveTo(baseX, y);
        ctx.lineTo(baseX - 8, y);
        ctx.lineWidth = 1;
        ctx.stroke();
      }
    }
  }
}


// function createPatternCanvas(
//   url,
//   repeatWidthInches,
//   widthInches,
//   heightInches,
//   elementId,
//   dpi = 96,
//   maxSize = 1200
// ) {
//   var MIN_CANVAS_SIZE = 250;
//   const $canvas = $("#" + elementId);
//   if ($canvas.length === 0) {
//     console.error("Canvas not found:", elementId);
//     return;
//   }

//   // Convert inches → pixels
//   let pxPerInch = dpi;
//   let canvasWidth = Math.round(widthInches * pxPerInch);
//   let canvasHeight = Math.round(heightInches * pxPerInch);

//   // Scale down if too large
//   let scale = 1;
//   if (canvasWidth > maxSize || canvasHeight > maxSize) {
//     scale = Math.min(maxSize / canvasWidth, maxSize / canvasHeight);
//     canvasWidth = Math.round(canvasWidth * scale);
//     canvasHeight = Math.round(canvasHeight * scale);
//     pxPerInch *= scale;
//     console.warn("Canvas scaled down, new size:", canvasWidth, canvasHeight);
//   }

//   const canvas = $canvas[0];
//   canvas.width = canvasWidth;
//   canvas.height = canvasHeight;
//   const ctx = canvas.getContext("2d");

//   const img = new Image();
//   img.crossOrigin = "anonymous";
//   img.src = url;

//   img.onload = function () {
//     // Maintain aspect ratio
//     const aspectRatio = img.height / img.width;

//     // Repeat size in px
//     const repeatWidthPx = repeatWidthInches * pxPerInch;
//     const repeatHeightPx = repeatWidthPx * aspectRatio;

//     for (let y = 0; y < canvasHeight; y += repeatHeightPx) {
//       for (let x = 0; x < canvasWidth; x += repeatWidthPx) {
//         ctx.drawImage(img, x, y, repeatWidthPx, repeatHeightPx);
//       }
//     }
//   };

//   img.onerror = function () {
//     console.error("Failed to load image:", url);
//   };
// }

function createPatternCanvas(
  url,
  repeatWidthInches,
  widthInches,
  heightInches,
  elementId,
  dpi = 96,
  maxSize = 1200
) {
  var MIN_CANVAS_SIZE = 250;
  const $canvas = $("#" + elementId);
  if ($canvas.length === 0) {
    console.error("Canvas not found:", elementId);
    return;
  }

  // Convert inches → pixels
  let pxPerInch = dpi;
  let canvasWidth = Math.round(widthInches * pxPerInch);
  let canvasHeight = Math.round(heightInches * pxPerInch);

  // Scale UP if too small (so tiny dimensions don't render as a tiny image)
  if (canvasWidth < MIN_CANVAS_SIZE && canvasHeight < MIN_CANVAS_SIZE) {
    let upScale = MIN_CANVAS_SIZE / Math.max(canvasWidth, canvasHeight);
    canvasWidth = Math.round(canvasWidth * upScale);
    canvasHeight = Math.round(canvasHeight * upScale);
    pxPerInch *= upScale;
    console.warn("Canvas scaled up, new size:", canvasWidth, canvasHeight);
  }

  // Scale down if too large
  let scale = 1;
  if (canvasWidth > maxSize || canvasHeight > maxSize) {
    scale = Math.min(maxSize / canvasWidth, maxSize / canvasHeight);
    canvasWidth = Math.round(canvasWidth * scale);
    canvasHeight = Math.round(canvasHeight * scale);
    pxPerInch *= scale;
    console.warn("Canvas scaled down, new size:", canvasWidth, canvasHeight);
  }

  const canvas = $canvas[0];
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  const ctx = canvas.getContext("2d");

  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = url;

  img.onload = function () {
    // Maintain aspect ratio
    const aspectRatio = img.height / img.width;

    // Repeat size in px
    const repeatWidthPx = repeatWidthInches * pxPerInch;
    const repeatHeightPx = repeatWidthPx * aspectRatio;

    for (let y = 0; y < canvasHeight; y += repeatHeightPx) {
      for (let x = 0; x < canvasWidth; x += repeatWidthPx) {
        ctx.drawImage(img, x, y, repeatWidthPx, repeatHeightPx);
      }
    }
  };

  img.onerror = function () {
    console.error("Failed to load image:", url);
  };
}

// function createPatternCanvas(url, repeatInches, widthInches, heightInches, elementId, dpi = 96, maxSize = 8000) {
//   const $canvas = $("#" + elementId);
//   if ($canvas.length === 0) {
//     console.error("Canvas not found:", elementId);
//     return;
//   }

//   // Convert inches to pixels at given dpi
//   let pxPerInch = dpi;
//   let canvasWidth = Math.round(widthInches * pxPerInch);
//   let canvasHeight = Math.round(heightInches * pxPerInch);

//   // Scale down if too large
//   let scale = 1;
//   if (canvasWidth > maxSize || canvasHeight > maxSize) {
//     scale = Math.min(maxSize / canvasWidth, maxSize / canvasHeight);
//     canvasWidth = Math.round(canvasWidth * scale);
//     canvasHeight = Math.round(canvasHeight * scale);
//     pxPerInch *= scale; // adjust ratio
//     console.warn("Canvas scaled down, new size:", canvasWidth, canvasHeight);
//   }

//   const canvas = $canvas[0];
//   canvas.width = canvasWidth;
//   canvas.height = canvasHeight;
//   const ctx = canvas.getContext("2d");

//   const img = new Image();
//   img.crossOrigin = "anonymous";
//   img.src = url;

//   img.onload = function () {
//     const repeatSizePx = repeatInches * pxPerInch;

//     for (let y = 0; y < canvasHeight; y += repeatSizePx) {
//       for (let x = 0; x < canvasWidth; x += repeatSizePx) {
//         ctx.drawImage(img, x, y, repeatSizePx, repeatSizePx);
//       }
//     }
//   };

//   img.onerror = function () {
//     console.error("Failed to load image:", url);
//   };
// }


$('#show_ruler').click(function () {
    $('#product_image').toggleClass('ruler-active');
     if (!$(this).hasClass('active')) {
      canvasRulerInit();
     }
    $(this).toggleClass('active');
});

// When button is clicked
$('#show_lengths').click(function () {
  $(this).toggleClass('active');

  // Toggle input state
  switch_input.checked = $(this).hasClass('active');

  // Trigger the switch change logic (to keep everything in sync)
  switch_input.dispatchEvent(new Event('change'));
});



$('#flip').click(function () {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
        $('#properties-flip').val('true');
    } else {
        $('#properties-flip').val('false');
    }
    $('#chartContainer').toggleClass('flip');
});

$('.material-js').click(function () {
  $(this).toggleClass('active');
  if ($(this).hasClass('active')) {
    $('.popup').attr('data','material');
    $('.popup__overlay').addClass('open');
  } else {
    $('.popup').removeAttr('data');
    $('.popup__overlay').removeClass('open');
  }
  canvasRulerInit();
});


$('.dimensions-js').click(function () {
  $(this).toggleClass('active');
  if ($(this).hasClass('active')) {
    $('.popup').attr('data','dimensions');
    $('.popup__overlay').addClass('open');
  } else {
    $('.popup').removeAttr('data');
    $('.popup__overlay').removeClass('open');
  }
  canvasRulerInit();
});



$('.popup__overlay').click(function () {
  $('.dimensions-js').removeClass('active');
  $('.material-js').removeClass('active');
  $('.popup').removeAttr('data');
  $('.popup__overlay').removeClass('open');
    canvasRulerInit();
});

$(document).on("click", ".walltool-mobile-toolbar-cart-button", function () {
    $("#ms_sp_addto_cart").trigger("click");
});

